export const SET_SUMMARY = 'SET_SUMMARY'
export const SET_CLIENTS = 'SET_CLIENTS'
export const SET_PAGER = 'SET_PAGER'
export const SET_WEEK = 'SET_WEEK'
export const RESET_WEEK = 'RESET_WEEK'
export const SET_FILTER = 'SET_FILTER'
export const SET_LISTS = 'SET_LISTS'
export const RESET_LISTS = 'RESET_LISTS'
export const SET_LIST = 'SET_LIST'
export const SET_MEMBERS = 'SET_MEMBERS'
export const SET_MEMBER = 'SET_MEMBER'
export const SET_MEMBERIDS = 'SET_MEMBERIDS'
export const SET_MEMBERIDS_DIRECT = 'SET_MEMBERIDS_DIRECT'
export const SET_MEMBER_GOALS = 'SET_MEMBER_GOALS'
export const SET_MEMBER_DAILYPROGRESS = 'SET_MEMBER_DAILYPROGRESS'
export const SET_MEMBER_PROFILEHISTORY = 'SET_MEMBER_PROFILEHISTORY'
export const SET_MEMBER_SESSION_HEARTRATES = 'SET_MEMBER_SESSION_HEARTRATES'
export const SET_MEMBER_SESSION_DETAIL = 'SET_MEMBER_SESSION_DETAIL'
export const SET_ZONE_PROFILE = 'SET_ZONE_PROFILE'
export const SET_ZONE_PROFILE_HISTORY = 'SET_ZONE_PROFILE_HISTORY'
export const REMOVE_PROFILE_HISTORY = 'REMOVE_PROFILE_HISTORY'
export const SET_SELECTED_VIEW = 'SET_SELECTED_VIEW'
export const RESET_SELECTED_VIEW = 'RESET_SELECTED_VIEW'
export const SET_CUSTOM_COLUMN = 'SET_CUSTOM_COLUMN'
export const SET_CUSTOM_VIEWS = 'SET_CUSTOM_VIEWS'
export const UPDATE_CUSTOM_VIEW = 'UPDATE_CUSTOM_VIEW'
export const SET_STARLEVEL = 'SET_STARLEVEL'
export const SET_MEMBER_DATA = 'SET_MEMBER_DATA'
export const SET_CHALLENGE_STATS = 'SET_CHALLENGE_STATS'
export const SET_LIBRARYNAME = 'SET_LIBRARYNAME'
export const SET_CHALLENGENAME = 'SET_CHALLENGENAME'
export const SET_DASHBOARDNAME = 'SET_DASHBOARDNAME'
export const UPDATE_MEMBER_DATA = 'UPDATE_MEMBER_DATA'
export const SET_UNREAD_MESSAGES = 'SET_UNREAD_MESSAGES'
export const SET_CHECKED = 'SET_CHECKED'
export const SET_CHECKED_INLIST = 'SET_CHECKED_INLIST'
export const SET_CUSTOM_VIEWS_CONFIG = 'SET_CUSTOM_VIEWS_CONFIG'
export const SET_MEMBER_DAILYPROGRESS_DATA = 'SET_MEMBER_DAILYPROGRESS_DATA'

export const STORE_PAGER = 'usercardio/pager'
export const STORE_CUSTOM_VIEW = 'usercardio/customizeview'
export const STORE_FILTER = 'usercardio/filter'
export const STORE_LISTS = 'usercardio/lists'
export const STORE_SELECTEDVIEW = 'usercardio/selectedview'
